
import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { useNavigate, useLocation } from "react-router-dom";
import { useSubscription } from "@/hooks/useSubscription";
import { SignInForm } from "@/components/auth/SignInForm";
import { SignUpForm } from "@/components/auth/SignUpForm";
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";

const Auth = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const modeParam = queryParams.get('mode');
  
  const [mode, setMode] = useState<"signin" | "signup" | "reset">(
    modeParam === "signup" ? "signup" : "signin"
  );
  
  const navigate = useNavigate();
  const { selectedTier } = useSubscription();

  useEffect(() => {
    if (mode === "signup" && !selectedTier && !modeParam) {
      navigate("/");
    }
  }, [mode, selectedTier, navigate, modeParam]);

  // Only redirect if they came through the subscription flow and no mode param was specified
  if (mode === "signup" && !selectedTier && !modeParam) {
    navigate("/");
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tighter">
            {mode === "signin" ? "Welcome Back" : mode === "signup" ? "Create Account" : "Reset Password"}
          </h1>
          <p className="text-gray-600 mt-2">
            {mode === "signin"
              ? "Sign in to access your account"
              : mode === "signup"
              ? "Sign up to get started"
              : "Enter your email to reset your password"}
          </p>
        </div>

        <Card className="p-6">
          {mode === "signin" && <SignInForm onModeChange={setMode} />}
          {mode === "signup" && <SignUpForm onModeChange={setMode} />}
          {mode === "reset" && <ResetPasswordForm onModeChange={setMode} />}
        </Card>
      </div>
    </div>
  );
};

export default Auth;
